import "./ClearingHouseInsurancePreviewComponent.scss";
import {ITableColumn} from "../../../../shared/models/table.model";
import React, {useEffect} from "react";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import TableWrapperV2Component
    from "../../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import {APIConfig} from "../../../../constants";
import TableV2Component from "../../../../shared/components/table-components/table-v2/TableV2Component";
import useFetch from "../../../../shared/hooks/useFetch";

interface ClearingHouseInsurancePreviewComponentProps {
    modalConfig: {
        isOpen: boolean,
        clearingHouse: string | null,
        modalType: "view" | "add",
        clearingHouseId: string | number | null,
        sessionFile: File | null,
    }
    onClose: (value: React.SetStateAction<{
        isOpen: boolean,
        clearingHouse: string | null,
        modalType: "view" | "add",
        clearingHouseId: string | number | null,
        sessionFile: File | null,
    }>) => void;
    onSubmit: (value: React.SetStateAction<{ isOpen: boolean }>) => void;
}

const ClearingHouseInsurancePreviewComponent = (props: ClearingHouseInsurancePreviewComponentProps) => {
    const {modalConfig, onClose, onSubmit} = props;
    const {
        response: sessionFilePreviewData,
        loading: isSessionFileLoading,
        loadingFailed: isSessionFileFailed,
        fetchData: fetchSessionFilePreview,
    } = useFetch<any>();

    useEffect(() => {
        if (modalConfig.modalType === 'add' && modalConfig.isOpen && modalConfig.sessionFile) {
            const formData = new FormData();
            formData.append('file', modalConfig.sessionFile);
            fetchSessionFilePreview({
                url: APIConfig.VIEW_CLEARING_HOUSE_SESSION_LIST.URL,
                method: APIConfig.VIEW_CLEARING_HOUSE_SESSION_LIST.METHOD,
                payload: formData
            })
        }
    }, [fetchSessionFilePreview, modalConfig.isOpen, modalConfig.modalType, modalConfig.sessionFile]);
    const insuranceListColumn: ITableColumn[] = [
        // {
        //     id: "clearingHouse",
        //     label: "Clearing House",
        //     isDefaultColumn: true,
        //     width: "200",
        //     fixed: "left"
        // },
        {
            id: "payerName",
            label: "Payer Name",
            isDefaultColumn: true,
            width: "250",
            // fixed: "left"
        },
        {
            id: "payerId",
            label: "Payer Id",
            isDefaultColumn: true,
            width: "100",
        },
        {
            id: "CPID",
            label: "CPID",
            isDefaultColumn: true,
            width: "100",
        },
        {
            id: "type",
            label: "Type",
            isDefaultColumn: true,
            width: "200",
            fixed: "right"
        },
        // {
        //     id: "groupId",
        //     label: "Group ID",
        //     isDefaultColumn: true,
        //     width: "200",
        //     fixed: "left"
        // },
    ]
    return (
        <div className={'clearing-house-insurance-preview-component page-data-wrapper screen'}>
            <div className={'clearing-house-insurance-list'}>
                {/*<TableComponent*/}
                {/*    size={"small"}*/}
                {/*    columns={insuranceListColumn}*/}
                {/*    data={Array.from({length: 50}, (_, index) => ({*/}
                {/*        clearingHouse: `Clearing House ${index + 1}`,*/}
                {/*        payerName: `Payer Name ${index + 1}`,*/}
                {/*        payerId: `PayerID-${index + 1}`,*/}
                {/*        CPID: `CPID-${index + 1}`,*/}
                {/*        type: index % 2 === 0 ? 'Health' : 'Dental', // alternating types*/}
                {/*        // groupId: `GroupID-${index + 1}`*/}
                {/*    }))}*/}
                {/*    isStickyHeader={true}*/}
                {/*/>*/}
                <div className={'clearing-house-list-container table-list-container'}>
                    {modalConfig.modalType === 'view' && modalConfig.isOpen && modalConfig.clearingHouseId &&
                        <TableWrapperV2Component
                            isPaginated={false}
                            columns={insuranceListColumn}
                            url={APIConfig.VIEW_CLEARING_HOUSE_INSURANCE_LIST.URL(modalConfig.clearingHouseId)}
                            method={APIConfig.VIEW_CLEARING_HOUSE_INSURANCE_LIST.METHOD}
                            isColumnFilterVisible={false}
                            isStickyHeader={true}
                        />
                    }
                    {modalConfig.modalType === 'add' && modalConfig.isOpen && modalConfig.sessionFile &&
                        <div className={'t-table-container'}>
                            <TableV2Component
                                columns={insuranceListColumn}
                                data={sessionFilePreviewData}
                                loading={isSessionFileLoading}
                                errored={isSessionFileFailed}
                                fixedHeader={true}
                            />
                        </div>
                    }
                </div>
            </div>
            {
                modalConfig.modalType === 'add' && (
                    <div className="clearing-house-action-modal mrg-top-15">
                        <ButtonComponent
                            handleClick={onClose}
                            color={'secondary'}
                            // fullWidth={true}
                            variant={"outlined"}>
                            Cancel
                        </ButtonComponent>
                        <ButtonComponent
                            handleClick={onSubmit}
                            color={"error"}
                            // fullWidth={true}
                            variant={"contained"}>
                            Proceed
                        </ButtonComponent>
                    </div>
                )
            }
        </div>
    );

};

export default ClearingHouseInsurancePreviewComponent;
